
import { useState } from 'react';

interface ProductCardProps {
  id: string;
  image: string;
  brand: string;
  name: string;
  price: string;
  originalPrice?: string;
  isNew?: boolean;
  onClick?: () => void;
}

const ProductCard = ({ id, image, brand, name, price, originalPrice, isNew, onClick }: ProductCardProps) => {
  return (
    <div 
      className="group cursor-pointer transition-all duration-300 hover:shadow-lg"
      onClick={onClick}
    >
      {/* Product Image */}
      <div className="relative overflow-hidden rounded-lg mb-3">
        <img
          src={image}
          alt={name}
          className="w-full h-64 md:h-80 object-cover transition-transform duration-300 group-hover:scale-105"
        />
        {isNew && (
          <span 
            className="absolute top-2 left-2 px-2 py-1 text-xs font-semibold text-white rounded-full"
            style={{ backgroundColor: '#0F3F2F' }}
          >
            NEW
          </span>
        )}
        
        {/* Quick Action Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
          <button
            className="opacity-0 group-hover:opacity-100 transition-all duration-300 px-4 py-2 text-white font-semibold rounded-lg transform translate-y-2 group-hover:translate-y-0"
            style={{ backgroundColor: '#0F3F2F' }}
          >
            Ver Detalhes
          </button>
        </div>
      </div>

      {/* Product Info */}
      <div className="space-y-1">
        <p 
          className="text-xs font-medium uppercase tracking-wide"
          style={{ 
            color: '#C0C0C0',
            fontFamily: 'Montserrat, sans-serif'
          }}
        >
          {brand}
        </p>
        <h3 
          className="text-sm font-medium line-clamp-2"
          style={{ 
            color: '#0B0B0B',
            fontFamily: 'Montserrat, sans-serif'
          }}
        >
          {name}
        </h3>
        <div className="flex items-center space-x-2">
          <span 
            className="text-lg font-bold"
            style={{ 
              color: '#0F3F2F',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            {price}
          </span>
          {originalPrice && (
            <span 
              className="text-sm line-through"
              style={{ color: '#C0C0C0' }}
            >
              {originalPrice}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
